import { em } from 'polished'
import styled from 'styled-components'

export const Wrapper = styled.div`
  max-width: 90%;
  width: ${em(420)};
  height: ${em(400)};
  margin: 0 auto;

  ${p => p.theme.mq.upMd} {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, 10%);
    width: ${em(520)};
    max-width: 100%;
  }

  ${p => p.theme.mq.upLg} {
    left: 0;
    transform: translate(-15%, -5%);
    width: ${em(684)};
  }
`
